import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Spin, message } from 'antd';

import BlockWrapper from './BlockWrapper';
import ExchangeDetails from './Exchange';
import ToDoList from './ToDoList';
import Wrapper from './style';
import TradeAction from '../../actions/TradeAction';
import ConstantActions from '../../actions/ConstantAction';
import Card from './card';
import CARD_SECTIONS from './utils';
import PaymentModal from '../ExchangeBilling/Payment';
import { getTabParams } from '../../common/utils';
import { getExchangeBilling, getNewExchangeBilling, getPrice, setExchangePlan, getFeeData } from '../../common/fetch';
import moment from 'moment';
import { ExchangeAction } from '../../actions';

class Dashboard extends Component {
    constructor() {
        super()
        this.state = {
            users: [],
            isLoading: true,
            todoLoad: true,
            isEdit: false,
            priceData: {},
            isPayment: false,
            pendingInvoice: {},
            type: 'basic',
            isMonthly: false,
            isAutomatedKYC: false,
            isPendingPay: false,
            isOpenPlanModal: false,
            headerType: '',
            tabParams: getTabParams(),
            contentType: 'price',
            hideBreadcrumb: false,
        }
    }

    componentDidMount() {
        this.getData();
        setTimeout(() => {
            this.setState({ todoLoad: true })
        }, 2000)

        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('fiatSetup');
        if (window.location.search.indexOf('fiatSetup') > -1 && myParam === 'true') {
            if (window.history.pushState) {
                var newURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.pushState({ path: newURL }, '', newURL);
            }
            this.setState({
                contentType: 'fiat-application',
                isPayment: true,
                hideBreadcrumb: true
            });
        }
        if (this.state.tabParams
            && this.state.tabParams.isPayment) {
            this.setState({
                isPayment: this.state.tabParams.isPayment === 'true',
                isAutomatedKYC: true
            });
        }
    }

    getData = async () => {
        await this.getExchangePrice();
        await this.getConstant();
        if (this.props.exchange && this.props.exchange.id) {
            this.setState({ isLoading: true });
            this.setState({ isLoading: false });
        }
    };

    getConstant = async () => {
        try {
            const res = await getFeeData();
            if (res.data) {
                this.props.setConstant(res.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    handleApplyChanges = () => {
        this.props.requestApplyChangesModal({ isOpenApplyModal: true });
    };

    getExchangePrice = async () => {
        this.setState({ isLoading: true });
        try {
            const res = await getPrice();
            let priceData = {};
            Object.keys(res.data).forEach((key) => {
                let temp = res.data[key];
                if (!temp.month) {
                    temp.month = {};
                }
                if (!temp.year) {
                    temp.year = {};
                }
                priceData[key] = { ...temp };
            });
            this.setState({ priceData });
            this.setState({ isLoading: false });
        } catch (error) {
            if (error.data && error.data.message) {
                message.error(error.data.message);
                this.setState({ isLoading: false });
            }
        }
    }

    getInvoice = async (params) => {
        this.setState({ isLoading: true });
        try {
            const res = await getExchangeBilling(params);
            if (res.data && res.data.data) {
                const invoice = res.data.data.sort((a, b) => {
                    const AD = new Date(a.created_at);
                    const BD = new Date(b.created_at);
                    return AD >= BD ? -1 : 1;
                });
                if (!params) {
                    let paid = invoice.filter((val) => val.is_paid);
                    let pending = invoice.filter((val) => !val.is_paid);
                    this.props.storeBilling({ paidBilling: paid, pendingBilling: pending });
                } else if (params.is_paid) {
                    this.props.storeBilling({ paidBilling: invoice });
                } else {
                    this.props.storeBilling({ pendingBilling: invoice });
                }
                this.setState({ isLoading: false });
            }
        } catch (error) {
            console.error(error);
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error(error.message);
            }
            this.setState({ isLoading: false });
        }
    };

    openPaymentModal = async () => {
        const exchange = this.props.exchange || {};
        if (exchange.is_paid && exchange.expiry && moment().isAfter(moment(exchange.expiry))) {
            try {
                const resInvoice = await getNewExchangeBilling(exchange.id);
                if (resInvoice.data) {
                    this.setState({
                        pendingInvoice: resInvoice.data,
                        isPayment: true,
                        contentType: 'payment'
                    });
                    this.getInvoice();
                }
            } catch (error) {
                console.error(error);
                if (error.data && error.data.message) {
                    message.error(error.data.message);
                } else {
                    message.error(error.message);
                }
            }
        } else {
            this.setState({
                isPayment: true,
                contentType: this.state.isEdit ? 'payment' : 'price'
            });
        }
        // handlePayment(true);
        // handleContent('price');
    };

    closePaymentModal = () => {
        const exchange = this.props.exchange || {};
        this.setState({
            isPayment: false,
            isMonthly: exchange.period === 'month'
                ? true
                : false,
            isEdit: false,
            hideBreadcrumb: false,
            isAutomatedKYC: false,
            isPendingPay: false
        });
    };

    handleSelect = (type) => {
        this.setState({ type });
    };

    handleToggle = (checked) => {
        this.setState({ isMonthly: checked });
    };

    handleOpenPlanModal = (value) => {
        this.setState({
            isOpenPlanModal: true,
            headerType: value,
        });
    };

    onCancelPlanModal = () => {
        this.setState({ isOpenPlanModal: false, isAlert: false });
    };

    updatePlanType = async (params, callback = () => { }) => {
        try {
            const res = await setExchangePlan(params);
            if (this.props.exchange
                && this.props.exchange
                && this.props.exchange.id
                && params.plan !== "fiat"
            ) {
                const resInvoice = await getNewExchangeBilling(this.props.exchange.id);
                if (resInvoice.data) {
                    this.setState({ pendingInvoice: resInvoice.data });
                    this.getInvoice();
                }
            }
            if (res.data) {
                // this.onCancelPlanModal();
                this.getExchange();
                callback();
            }
        } catch (error) {
            console.error(error);
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error(error.message);
            }
        }
    };

    updateTabParams = (params) => {
        let tabParams = getTabParams();
        if (params) {
            this.setState({ tabParams: params, isPayment: true, isAutomatedKYC: true })
        } else {
            this.setState({ tabParams })
        }
    };

    render() {

        const { exchange, constant, isStatLoading, user, history, storeExchange } = this.props;
        const { isLoading, todoLoad, isEdit, priceData, tabParams, type, isAutomatedKYC, isPendingPay, isPayment, isMonthly, headerType, contentType, hideBreadcrumb, pendingInvoice } = this.state;
        const currentExchange = exchange || {};

        if (isLoading || isStatLoading) {
            return (
                <Wrapper>
                    <Spin />
                </Wrapper>
            );
        }
        return (
            <Wrapper>
                <div className='dashboard-wrapper'>
                    <div className="container">
                        <div className="content-wrapper-1">
                            <BlockWrapper title="My exchange">
                                <ExchangeDetails
                                    exchange={exchange}
                                    constant={constant}
                                />
                            </BlockWrapper>
                        </div>
                        {todoLoad ? <div className="content-wrapper-2">
                            <span className="content-border"></span>
                            <BlockWrapper title="To do list">
                                <ToDoList
                                    exchange={exchange}
                                    handleApplyChanges={this.handleApplyChanges}
                                    type="dashboard"
                                    user={user}
                                    constant={constant}
                                    todoLoad={todoLoad}
                                />
                            </BlockWrapper>
                        </div> : null}
                    </div>
                    {CARD_SECTIONS.map(items => {
                        return <Card image={items.image}
                            header={items.header}
                            description={items.description}
                            link={items.link}
                            backgroundImage={items.background}
                            linkPath={items.linkPath}
                        />
                    })}
                    {isPayment && (
                        <PaymentModal
                            isEdit={isEdit}
                            balance={user.balance || {}}
                            priceData={priceData}
                            history={history}
                            isOpen={isPayment}
                            invoiceData={pendingInvoice}
                            exchange={currentExchange}
                            type={type}
                            isMonthly={isMonthly}
                            contentType={contentType}
                            headerType={headerType}
                            getInvoice={this.getInvoice}
                            onOk={this.openPaymentModal}
                            onCancel={this.closePaymentModal}
                            handleSelect={this.handleSelect}
                            handleToggle={this.handleToggle}
                            handleOpenPlanModal={this.handleOpenPlanModal}
                            onCancelPlanModal={this.onCancelPlanModal}
                            updatePlanType={this.updatePlanType}
                            hideBreadcrumb={hideBreadcrumb}
                            actions={storeExchange}
                            isAutomatedKYC={isAutomatedKYC}
                            tabParams={tabParams}
                            updateTabParams={this.updateTabParams}
                            isPendingPay={isPendingPay}
                            currentPage={'/dashboard'}
                        />
                    )}
                </div>
            </Wrapper>
        )
    }
};

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
    pairs: state.pair,
    trades: state.trade.trades,
    prices: state.trade.prices,
    constant: state.constant,
    isStatLoading: state.stat.isLoading,
    coins: state.coin,
    user: state.user
});

const mapDispatchToProps = (dispatch) => ({
    setTrades: bindActionCreators(TradeAction.setTrades, dispatch),
    requestApplyChangesModal: bindActionCreators(ConstantActions.requestApplyChangesModal, dispatch),
    setConstant: bindActionCreators(ConstantActions.readData, dispatch),
    storeExchange: bindActionCreators(ExchangeAction.readData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
